import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import CgFormCreator from "../../common/CgFormCreator";
import "./AddPractice.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { addPracticeInfoDetailsAPI } from '../../store/Admin/AddPracticeActions';
import statesData from '../../utils/commonUtilities';


const validPostalCode = /^[0-9]{5}$/;
const validPhoneNumber = /^\d{10}$/;
const validUrl = /^(https?:\/\/)?([\w-]+\.)+[a-z]{2,}(\/[\w-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


const AddPractice = () => {

    const [validatedValues, setValidatedValues] = useState({
        name: "",
        street1: "",
        city: "",
        state: "",
        email: "",
        postalCode: "",
        phoneNumber: "",
        website: ""
    });

    const [errors, setErrors] = useState({});
    const [showError, setShowError] = useState(false);


    const { addPracticeErrorMsg } = useSelector((state) => state?.addPracticeData);

    const dispatch = useDispatch();
    const navigate = useNavigate();


    useEffect(() => {
        let newErrors = {};
        if (validatedValues?.name?.length === 0) {
            newErrors.name = "Practice name is required";
        }
        if (validatedValues?.street1?.length === 0) {
            newErrors.street1 = "Street Address 1 is required";
        }
        if (validatedValues?.city?.length === 0) {
            newErrors.city = "City is required";
        }
        if (validatedValues?.state?.length === 0) {
            newErrors.state = "State is required";
        }
        if (validatedValues?.postalCode?.length === 0 || validatedValues?.postalCode?.length < 1 || !validPostalCode.test(validatedValues?.postalCode)) {
            newErrors.postalCode = "ZipCode must be at least 1 characters";
        }
        if (validatedValues?.phoneNumber?.length === 0 || !validPhoneNumber.test(validatedValues?.phoneNumber)) {
            newErrors.phoneNumber = 'Phone number must be exactly 10 digits and contain only numbers.';
        }
        if (validatedValues?.email?.length > 0 && !validEmail.test(validatedValues?.email)) {
            newErrors.email = 'Please enter a valid email address';
        }
        if (validatedValues?.website?.length >= 2 && !validUrl.test(validatedValues?.website)) {
            newErrors.website = 'Please enter a valid website url';
        }
        setErrors(newErrors)
    }, [validatedValues]);



    useEffect(() => {
        if (addPracticeErrorMsg) {
            setShowError(true);
            setTimeout(() => {
                setShowError(false);
            }, 2000);
        }
    }, [addPracticeErrorMsg]);


    const getfilteredValues = (data) => {
        const filteredValues = {};
        for (const key in data) {
            if (data[key] !== "") {
                filteredValues[key] = data[key];
            }
        }
        return filteredValues;
    }


    const handleAddPracticeFormData = (formData) => {
        setErrors({})
        const filteredFormData = getfilteredValues(formData);
        const payload = {
            ...filteredFormData,
            website: validatedValues?.website
        }
        if (payload.website.length === 0) {
            delete payload.website;
        }
        dispatch(addPracticeInfoDetailsAPI(payload)).then((response) => {
            if (response?.payload?.data?.data?.practiceExtendedResponseDTO) {
                const displayId = response?.payload?.data?.data?.practiceExtendedResponseDTO.displayId;
                navigate(`/practice/${displayId}/profile-information/info`)
            }
        })
    }


    const AddPracticeSchema = [
        {
            component: "input",
            label: "PRACTICE NAME",
            type: "text",
            name: "name",
            required: true,
            placeholder: " ",
            className: errors?.name ? "errorBorder" : "addPracticeFields",
            onKeyChangeCallback: (name, value) => { setValidatedValues({ ...validatedValues, [name]: value }) },
            valueChangeCallback: () => { },
        },
        {
            component: "input",
            type: "text",
            label: "ADDRESS STREET 1",
            name: "street1",
            className: errors?.street1 ? "errorBorder" : "addPracticeFields",
            placeholder: " ",
            onKeyChangeCallback: (name, value) => { setValidatedValues({ ...validatedValues, [name]: value }) },
            valueChangeCallback: () => { },
            required: true,
        },
        {
            component: "input",
            type: "text",
            label: "ADDRESS STREET 2",
            name: "street2",
            placeholder: " ",
            className: "addPracticeFields",
            valueChangeCallback: () => { },
        },
        {
            component: "input",
            type: "text",
            label: "CITY",
            name: "city",
            className: errors?.city ? "errorBorder" : "addPracticeFields",
            placeholder: " ",
            onKeyChangeCallback: (name, value) => { setValidatedValues({ ...validatedValues, [name]: value }) },
            valueChangeCallback: () => { },
            required: true,
        },
        {
            component: "dropdown",
            label: "STATE",
            name: "state",
            dropdownOptions: statesData,
            dropdownClassName: errors?.state ? "errorBorder" : "stateSelect",
            dropdownPlaceHolder: "Select a state",
            onSelectCallBack: (name, value) => { setValidatedValues({ ...validatedValues, [name]: value }) },
            required: true,
        },
        {
            component: "input",
            type: "text",
            label: "ZIPCODE",
            name: "postalCode",
            minLength: 5,
            placeholder: " ",
            className: errors?.postalCode ? "errorBorder" : "addPracticeFields",
            onKeyChangeCallback: (name, value) => { setValidatedValues({ ...validatedValues, [name]: value }) },
            valueChangeCallback: () => { },
            required: true,
        },
        {
            component: "input",
            label: "OFFICE MANAGER",
            type: "text",
            name: "officeManager",
            className: "addPracticeFields",
            placeholder: " ",
            valueChangeCallback: () => { }
        },
        {
            component: "input",
            label: "PHONE",
            type: "text",
            name: "phoneNumber",
            required: true,
            minLength: 10,
            placeholder: "XXX-XXX-XXXX",
            className: errors?.phoneNumber ? "errorBorder" : "addPracticeFields",
            onKeyChangeCallback: (name, value) => { setValidatedValues({ ...validatedValues, [name]: value }) },
            valueChangeCallback: () => { }
        },
        {
            component: "input",
            label: "FAX",
            type: "text",
            name: "faxNumber",
            minLength: 10,
            className: "addPracticeFields",
            placeholder: "XXX-XXX-XXXX",
            valueChangeCallback: () => { }
        },
        {
            component: "input",
            label: "EMAIL",
            type: "email",
            name: "email",
            placeholder: " ",
            className: errors?.email ? "errorBorder" : "addPracticeFields",
            onKeyChangeCallback: (name, value) => { setValidatedValues({ ...validatedValues, [name]: value }) },
            valueChangeCallback: () => { },
        },
        {
            component: "input",
            label: "WEBSITE",
            type: "text",
            name: "website",
            placeholder: " ",
            className: errors?.website ? "errorBorder" : "addPracticeFields",
            onKeyChangeCallback: (name, value) => {
                if (value?.length >= 2 && !value?.startsWith('https://') && !value?.startsWith('http://')) {
                    let websiteUrl = `https://${value}`;
                    setValidatedValues({ ...validatedValues, [name]: websiteUrl })
                }
            },
            valueChangeCallback: () => { },
            defaultValue: validatedValues?.website || "",
        }
    ]



    const RenderAddPracticeDetailsError = () => {
        if (!showError) return null;
        return (
            <div className="overlay-alert alert alert-danger alertTopPosition" role="alert">
                {addPracticeErrorMsg}
            </div>
        )
    }

    const RenderAddPracticeFormCreator = () => {
        return (
            <div className="addPracticeWrapper">
                <h1>Add Practice</h1>
                <div className="addPracticeForm-without-border-style addPracticeForm">
                    <CgFormCreator
                        key={errors}
                        schema={AddPracticeSchema}
                        primaryButton="ADD"
                        onSubmitCallback={(value) => handleAddPracticeFormData(value)}
                        onCancel={() => navigate('/dashboard')}
                        resetValuesOnSubmit={Object.keys(errors)?.length == 0}
                        enablePrimaryBtn={Object.keys(errors)?.length == 0}
                        showErrorMsg={errors?.email}
                    />
                </div>
            </div>
        );
    };


    return (
        <>
            {RenderAddPracticeDetailsError()}
            {RenderAddPracticeFormCreator()}
        </>
    )
}

export default AddPractice;